import React, {useContext} from 'react';
import CbtNavbar from './CbtNavbar';
import CbtSidebar from './CbtSidebar';
import {DataContext} from '../context/DataContext';
import Sidebar from './Sidebar';
import FooterNav from './FooterNav'
import { animated, useSpring } from "react-spring";

const CbtShell = ({children}) => {
    const dataContext = useContext(DataContext)
    const showMenu = dataContext.showMenu;

    const transitionStyle = useSpring({
        to: [
            { opacity: 1, transform: 'translateY(0)' },
        ],
        from: { opacity: 0, transform: 'translateY(80px)' },
        config: { duration: 700 }
      });

    return (
    <>
        <div className="bg-gray-600 h-screen" >
            <div className="border-b z-10 border-gray-600 w-full bg-white">
                <CbtNavbar />
            </div>
            {showMenu && 
            <div className='mt-16 absolute'>
                <Sidebar />
            </div>
            }
            {/* <div className="flex w-full bg-gray-700 mb-32 sm:mt-16"> */}
            <div className="flex w-full bg-gray-700 mb-auto sm:mt-16">
                <animated.div style={transitionStyle} className="hidden fixed sm:flex flex-col max-h-screen bg-white mt-10 ml-8 rounded-lg w-1/5 z-0 pt-8 sm:px-4">
                    <span className="font-semibold text-sm text-gray-100 pl-1"> Assigned Subjects </span>
                    <div className="block bg-white h-full mb-4 z-0">
                        <CbtSidebar />
                    </div>
                </animated.div>
                <div className="w-full px-4 lg:pl-20 sm:ml-64 sm:px-1 sm:w-4/5 sm:pl-6">
                    {children}
                </div>
            </div>
            <div className='w-full mt-5 sm:hidden z-10 fixed flex justify-between left-0 bottom-0'>
                <FooterNav />
            </div>
        </div>
    </>
)};

export default CbtShell;